import { render, staticRenderFns } from "./VersionUpdate.vue?vue&type=template&id=0897fdaf&scoped=true&"
import script from "./VersionUpdate.vue?vue&type=script&lang=js&"
export * from "./VersionUpdate.vue?vue&type=script&lang=js&"
import style0 from "./VersionUpdate.vue?vue&type=style&index=0&id=0897fdaf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0897fdaf",
  null
  
)

export default component.exports